import {define, init, inject, singleton} from '@injex/core';
import BaseUserManager from '../base/BaseUserManager';
import LocalStorageManager from './LocalStorageManager.mdl';
import {INetwork} from '../interfaces/INetwork';
import {NetworkFeatures} from '../enums/NetworkFeatures';
import {UserRole} from '../enums/UserRole';
import {ImportantOrganizations} from '../enums/ImportantOrganizations';
import {SessionManager} from '../../modules/session/managers/sessionManager.mdl';
import {IUserMetadata} from '../../modules/session/interfaces/IUserMetadata';
import {ISession} from '../../modules/session/interfaces/IAccountsSDK';

@define()
@singleton()
export default class UserManager extends BaseUserManager {

    @inject() public localStorageManager: LocalStorageManager;
    @inject() private sessionManager: SessionManager;

    @init()
    protected initialize() {
        this.sessionManager.hooks.metadataLoad.tapAsync(this._onMetadataLoad, null, this);
    }

    private _onMetadataLoad(metadata: IUserMetadata, session: ISession) {
        this.setData(metadata.auth, session);
        this.localStorageManager.initialize(this._id);
    }

    public isInRoles = (scope: UserRole[]): boolean => {
        return (scope && scope.length > 0)
            ? scope.some((role) => this.roles.includes(role))
            : true;
    };

    public isBelongToUser(userId: string): boolean {
        if (!userId) return false;
        const legacyId = this.sessionManager.auth0User?.app_metadata?.apps?.supply?.legacyId;
        return this._id === userId || legacyId === userId;
    }
}
